<nav class="sidebar">
    <div class="sidebar-inner-wrap" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="sidebar-inner">
            <ul class="main-ul">
                <mat-accordion>
                    @for(menu of authorizedMenuItems; track menu.title) {
                        <li>
                            @if(menu.subMenus){
                            <mat-expansion-panel [expanded]="isPanelExpanded(menu)" class="sidebar-panel">
                                <mat-expansion-panel-header title="{{menu.title | translate}}" [ngClass]="{'active-parent-icon': isPanelExpanded(menu) && isSidebarCollapsed}">
                                    <mat-panel-title>
                                        @if(menu.svgIconUrl) {
                                            <mat-icon [svgIcon]="menu.svgIconUrl"></mat-icon>
                                        }
                                        @else if(menu.svgIcon) {
                                            <mat-icon>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <mask id="{{menu.svgIcon.maskId}}" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                        <rect width="24" height="24" fill="#D9D9D9" />
                                                    </mask>
                                                    <g [attr.mask]="'url(#' + menu.svgIcon.maskId + ')'">
                                                        <path [attr.d]="menu.svgIcon.pathD" [attr.fill]="menu.svgIcon.pathFillColor" />
                                                    </g>
                                                </svg>
                                            </mat-icon>
                                        }
                                        <span class="link-text" [ngClass]="{ 'active-parent': isPanelExpanded(menu) }">{{menu.title | translate}}</span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ul class="inside-ul">
                                    @for(subMenu of menu.subMenus; track subMenu.title) {
                                        <li>
                                            <a [routerLink]="subMenu.routerLink" title="{{subMenu.title | translate}}" class="{{isActive(subMenu) ? 'active child-background' : ''}}">
                                                <span class="link-text">{{subMenu.title | translate}}</span>
                                            </a>                                         
                                        </li>
                                    }
                                </ul>
                            </mat-expansion-panel>
                            }
                            @else{
                            <a [routerLink]="menu.routerLink" title="{{menu.title | translate}}" class="nav-link" [ngClass]="{ active: isActive(menu) }">
                                @if (menu.svgIcon) {
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <mask id="{{menu.svgIcon.maskId}}" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                            <rect width="24" height="24" fill="#D9D9D9" />
                                        </mask>
                                        <g [attr.mask]="'url(#' + menu.svgIcon.maskId + ')'">
                                            <path [attr.d]="menu.svgIcon.pathD" [attr.fill]="menu.svgIcon.pathFillColor" />
                                        </g>
                                    </svg>
                                }
                                @else if(menu.svgIconUrl) {
                                    <mat-icon [svgIcon]="menu.svgIconUrl"></mat-icon>
                                }
                                <span class="link-text">{{menu.title | translate}}</span>
                            </a>
                            }
                        </li>
                    }
                </mat-accordion>
            </ul>
        </div>
    </div>
</nav>